import type { HTMLAttributes } from "react";

export const FLOATING_ACTION_BAR_CLASSES =
  "fixed bottom-[calc(86px+env(safe-area-inset-bottom,0px))] left-1/2 z-40 flex w-max max-w-[calc(100vw-1rem)] -translate-x-1/2 flex-wrap items-center gap-3 rounded-[12px] border border-primary/35 bg-surface-container-high px-4 py-2.5 shadow-card md:bottom-6 md:max-w-[calc(100vw-2rem)]";

export type FloatingActionBarProps = HTMLAttributes<HTMLElement>;

/**
 * Gemeinsame Hülle für kontextabhängige Auswahl- und Quick-Actions.
 * Position, Safe-Area, Fläche, Rand, Radius, Schatten und Spacing leben nur
 * hier; die aufrufende Seite liefert ausschließlich ihre fachlichen Aktionen.
 */
export default function FloatingActionBar({
  className = "",
  children,
  ...props
}: FloatingActionBarProps) {
  return (
    <section
      data-slot="floating-action-bar"
      className={[FLOATING_ACTION_BAR_CLASSES, className].filter(Boolean).join(" ")}
      {...props}
    >
      {children}
    </section>
  );
}
